import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import moment from 'moment';
import { deviceName } from '../utils/config';
import { apiUrl } from '../utils/environment';

export const authApiSlice = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        baseUrl: apiUrl,
        prepareHeaders: (headers, { getState }) => {
            headers.set('accept', 'application/json');
            const token = getState().auth.token;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        loginMainUser: builder.mutation({
            query: (body) => ({
                url: '/login',
                method: 'POST',
                body,
            }),
        }),
        registerMainUser: builder.mutation({
            query: (body) => ({
                url: '/register',
                method: 'POST',
                body: {
                    ...body,
                    phoneNumber: '0' + body.phoneNumber,
                    dob: moment(body.dob).format('YYYY/MM/DD'),
                    device_name: deviceName,
                },
            }),
        }),
        updateUser: builder.mutation({
            query: ({ body, type }) => ({
                url: type ? `user/${type}` : 'user',
                method: 'PUT',
                body: {
                    ...body,
                    phoneNumber: '0' + body.phoneNumber,
                    dob: moment(body.dob).format('YYYY/MM/DD'),
                    device_name: deviceName,
                },
            }),
        }),
        requestCode: builder.mutation({
            query: (body) => ({
                url: '/reset/request',
                method: 'POST',
                body,
            }),
        }),
        createPassword: builder.mutation({
            query: (body) => ({
                url: '/reset',
                method: 'POST',
                body: {
                    ...body,
                    device_name: deviceName,
                },
            }),
        }),
        updateCredentials: builder.mutation({
            query: (body) => ({
                url: '/user/credentials',
                method: 'PUT',
                body,
            }),
        }),
        changeAvatar: builder.mutation({
            query: ({ image }) => {
                const formData = new FormData();
                formData.append('image', image[1]);
                return {
                    url: '/user',
                    method: 'POST',
                    body: formData,
                };
            },
        }),
        logout: builder.mutation({
            query: () => ({
                url: '/logout',
                method: 'DELETE',
            }),
        }),
        sendFcm: builder.mutation({
            query: (token) => ({
                url: '/fcm_token',
                method: 'POST',
                body: { token },
            }),
        }),
        updatePreferences: builder.mutation({
            query: (body) => ({
                url: '/preferences',
                method: 'PUT',
                body,
            }),
        }),
        getPreferences: builder.query({
            query: () => '/preferences',
        }),
    }),
});

export const {
    useLoginMainUserMutation,
    useRegisterMainUserMutation,
    useUpdateUserMutation,
    useRequestCodeMutation,
    useCreatePasswordMutation,
    useUpdateCredentialsMutation,
    useChangeAvatarMutation,
    useLogoutMutation,
    useSendFcmMutation,
    useUpdatePreferencesMutation,
    useGetPreferencesQuery,
} = authApiSlice;
